import React, { useEffect, useState } from 'react';
import OriginalCard from '../components/OriginalCard';
import { fetchPublicShows } from '../api/services';
import { Sparkles } from 'lucide-react';

const Originals = () => {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { fetchPublicShows().then(setShows).catch(() => setShows([])).finally(() => setLoading(false)); }, []);

  return (
    <div className="min-h-screen pt-16 px-10 pb-20">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-[#E50914] flex items-center justify-center"><Sparkles className="text-white" /></div>
        <div>
          <h1 className="font-display text-5xl md:text-6xl text-white">BLUNT Originals</h1>
          <p className="text-white/60 mt-1">Independent shows and films published by our creators.</p>
        </div>
      </div>

      <div className="mt-10">
        {loading ? (
          <div className="text-white/50">Loading…</div>
        ) : shows.length === 0 ? (
          <div className="p-10 text-center rounded-2xl bg-white/5 border border-white/10">
            <div className="text-white/70">No originals yet. Check back soon.</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-5">
            {shows.map((s) => <OriginalCard key={s.show_id} show={s} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Originals;
